import { useEffect, useRef, useState } from 'react';

const useInViewComponent = () => {
    const componentRef = useRef(null);
    const [isInView, setIsInView] = useState(false);

    const setupObserver = async (componentRef, hasShown) => {
        const componentElement = componentRef.current;

        if (!componentElement) {
            // console.error('Component element not found, observer not attached');
            return;
        }

        const observerCallback = (entries) => {
            entries.forEach((entry) => {

                if (entry.isIntersecting){
                    // Video is in view, play
                    setIsInView(true)
                    hasShown = true;
                } else {
                    // Video is out of view, pause

                    if (!hasShown){
                        setIsInView(false)
                    }
                }
            });
        };

        // Set up the observer with minimal threshold and rootMargin
        const observer = new IntersectionObserver(observerCallback, {
            threshold: [0], // Add more granular thresholds if needed
        });

        // Start observing the video element
        observer.observe(componentElement);

        return () => {
            // Clean up the observer when the component is unmounted
            if (componentElement) {
                observer.unobserve(componentElement);
            }
        };
    }
    useEffect(() => {
        setupObserver(componentRef);
    }, [componentRef]);

    return { componentRef , setupObserver, isInView};
};

export default useInViewComponent;
